import { ReactElement } from 'react'

interface DisplaySwitcherProps {
  displayList: ReactElement<any, any>[]
  currentStep: number
}

const DisplaySwitcher = ({ displayList, currentStep }: DisplaySwitcherProps) => {
  if (currentStep < 1 || currentStep > displayList.length) {
    throw new Error(
      'currentStep must be greater than 1 and less or equal to the displayList length'
    )
  }

  const display = displayList[currentStep - 1]

  if (!display) {
    throw new Error(
      `Element in position ${currentStep - 1} of displayList does not exist`
    )
  }
  return display
}

export default DisplaySwitcher
